module.exports = __webpack_public_path__ + "img/demo2-nutrition-ja.1e0714c5.png";